module.exports = __webpack_public_path__ + "static/media/confirmation.b8693e0d.gif";